import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Loader from '../Loader';
import CommentModal from '../siteadmin/ListingApprovalManagement/CommentModal/CommentModal';

import { approveListing, ManagePublishStatus, submitForVerification } from '../../actions/Listing/ManagePublishStatus';
import { closeCommentModal, openCommentModal } from '../../actions/modalActions';
import messages from '../../locale/messages';

import { CameraIcon, StepCompleteTickIcon } from '../Common/Assets/SvgComponent/commonSvgIcon';
import logoPrimary from '/public/eslipin-logo-secundario-blue.png';
import closeIcon from '/public/SiteIcons/loginClose.svg';
import iconOne from '/public/SiteIcons/pin.svg';
import personajeMapaMochila from '/public/SiteImages/personaje_mapa_mochila.svg';

import bt from '../../components/commonStyle.css';
import DropDownMenu from '../DropDownMenu/DropDownMenu';
import Link from '../Link/Link';
import Navigation from '../Navigation/Navigation';
import s from './ExistingPage.css';

class ExistingPage1 extends Component {
  static propTypes = {
    listingSteps: PropTypes.shape({
      step1: PropTypes.string.isRequired,
      step2: PropTypes.string.isRequired,
      step3: PropTypes.string.isRequired,
      guestDisplayName: PropTypes.string,
      listing: PropTypes.shape({
        id: PropTypes.number.isRequired,
        isReady: PropTypes.bool.isRequired,
        isPublished: PropTypes.bool.isRequired
      }),
      user: PropTypes.shape({
        userBanStatus: PropTypes.number,
      }),
      userData: PropTypes.shape({
        firstName: PropTypes.string.isRequired
      }).isRequired
    }),
    nextPage: PropTypes.any.isRequired,
    stepsLoading: PropTypes.bool,
    ManagePublishStatus: PropTypes.any.isRequired,
    publishListLoading: PropTypes.bool,
  };

  static defaultProps = {
    listingSteps: {
      step1: "inactive",
      step2: "inactive",
      step3: "inactive",
      step4: "active",
      listing: {
        id: 0,
        isReady: false,
        isPublished: false
      },
      user: {
        userBanStatus: 0,
      }
    },
    photosCount: 0,
    stepsLoading: false,
    publishListLoading: false,
    userData: {
      firstName: ''
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false
    };
  }

  openMenu = () => {
    this.setState({ isMenuOpen: true });
    if (typeof document !== 'undefined') {
      document.body.classList.add('menu-open');
    }
  };

  closeMenu = () => {
    this.setState({ isMenuOpen: false });
    if (typeof document !== 'undefined') {
      document.body.classList.remove('menu-open');
    }
  };

  handleApprove = async (event) => {
    const { approveListing, listingSteps: { listing: { id } }, openCommentModal } = this.props;
    if (event.target.value === 'approved') {
      await approveListing(id, 'approved');
    } else if (event.target.value === 'declined') {
      openCommentModal(id);
    }
  };

  handleDecline = async (listId, comment) => {
    const { closeCommentModal, approveListing } = this.props;
    await approveListing(listId, 'declined', comment);
    closeCommentModal();
  };

  render() {
    const { nextPage, listingSteps, photosCount, stepsLoading, account, publishListLoading, userData } = this.props;
    const { formatMessage } = this.props.intl;
    const { listingSteps: { listing: { id, isReady, isPublished, user, listApprovalStatus } } } = this.props;
    const { listingSteps: { step1, step2, step3, step4 } } = this.props;
    const { ManagePublishStatus, submitForVerification } = this.props;
    const { isMenuOpen } = this.state;

    let userDelete = user && user.userDeletedAt;
    let isShowButton = !userDelete;
    let isPhotoAvailable = photosCount > 0;
    let isAdmin = !account;
    let userBanStatusValue = user && user.userBanStatus;

    let stepFour = false;
    if (step3 === "active" || (step3 === "completed" && step4 === "active")) {
      stepFour = true;
    }

    if (stepsLoading) {
      return <Loader type={"text"} />;
    }

    const userName = (userData && userData.firstName) || 'Alex';

    return (
      <div className={s.pageRoot}>
        <CommentModal handleDecline={this.handleDecline} />

        {/* Top Header */}
        <header className={s.pageHeader}>
          <div className={s.headerInner}>
            <div className={s.headerLeft}>
              <Link to={'/'} className={s.headerLogoLink}>
                <img src={logoPrimary} className={s.headerLogo} alt="eslipin" />
              </Link>
            </div>

            <nav className={s.headerNav}>
              <Link to="/about" className={s.headerNavLink}>
                Quiénes somos
              </Link>
              <span className={s.navDivider}></span>
              <Link to="/become-a-host" className={cx(s.headerNavLink, s.headerNavLinkActive)}>
                Conviértete en anfitrión
              </Link>
              <span className={s.navDivider}></span>
              <Link to="/safety" className={s.headerNavLink}>
                Seguro Eslipin
              </Link>
              <span className={s.navDivider}></span>
              <Link to="/contact" className={s.headerNavLink}>
                Contáctanos
              </Link>
            </nav>

            <div className={s.headerRight}>
              <div className={s.dropdownBtn} onClick={this.openMenu}>
                <DropDownMenu />
              </div>
            </div>

            {/* Mobile slide menu */}
            <div className={cx(s.mobileMenu, { [s.menuOpen]: isMenuOpen })}>
              <div className={s.closeButtonPosition}>
                <div className={s.closeColor} onClick={this.closeMenu}>
                  <img src={closeIcon} alt="Cerrar" />
                </div>
              </div>
              <div onClick={this.closeMenu} className={s.mobileMenuContent}>
                <Navigation />
              </div>
            </div>
          </div>
        </header>

        {/* Main Content: Two Columns */}
        <main className={s.mainContainer}>
          <div className={s.cardsGrid}>
            {/* Left Card: Welcome greeting with character */}
            <div className={s.leftCard}>
              <div className={s.illustrationWrapper}>
                <img
                  src={personajeMapaMochila}
                  className={s.illustrationImg}
                  alt="Personaje con mapa y mochila"
                />
              </div>
              <h2 className={s.leftTitle}>
                <FormattedMessage {...messages.hi} />, <span className={s.leftUserName}>{userName}!</span>
              </h2>
              <p className={s.leftSubtitle}>
                Te guiaremos paso a paso para que puedas registrar tu alojamiento.
              </p>
            </div>

            {/* Right Card: Steps */}
            <div className={s.rightCard}>
              <div className={s.stepsList}>
                {/* Step 1 */}
                <div className={cx(s.stepItem, { [s.stepItemCompleted]: step1 === "completed" })}>
                  <div className={s.stepLeft}>
                    <div className={cx(s.stepIconCircle, { [s.stepIconCircleCompleted]: step1 === "completed" })}>
                      <img src={iconOne} className={s.stepIconImg} alt="" />
                      {step1 === "completed" && <StepCompleteTickIcon className={s.stepTickIcon} />}
                    </div>
                    <div className={s.stepDetails}>
                      <h3
                        className={s.stepTitle}
                        onClick={() => (step1 === "completed" ? nextPage('room') : nextPage('map'))}
                      >
                        <FormattedMessage {...messages.Sayyourspace} />
                      </h3>
                      <p className={s.stepDescription}>
                        Cuéntanos sobre la ubicación, el tipo de alojamiento, las comodidades y lo que lo hace especial.
                      </p>
                    </div>
                  </div>
                  <div className={s.stepAction}>
                    {step1 === "active" && (
                      <a href="javascript:void(0);" className={s.actionLink} onClick={() => nextPage('map')}>
                        <FormattedMessage {...messages.continue} />
                        <span className={s.chevronIcon}>&rsaquo;</span>
                      </a>
                    )}
                    {step1 === "completed" && (
                      <a href="javascript:void(0);" className={s.actionLink} onClick={() => nextPage('room')}>
                        <FormattedMessage {...messages.editLabel} />
                        <span className={s.chevronIcon}>&rsaquo;</span>
                      </a>
                    )}
                    {step1 !== "active" && step1 !== "completed" && (
                      <span className={s.chevronDisabled} onClick={() => nextPage('map')}>
                        &rsaquo;
                      </span>
                    )}
                  </div>
                </div>

                <div className={s.stepDivider}></div>

                {/* Step 2 */}
                <div className={cx(s.stepItem, { [s.stepItemCompleted]: step2 === "completed" && isPhotoAvailable })}>
                  <div className={s.stepLeft}>
                    <div className={cx(s.stepIconCircle, { [s.stepIconCircleCompleted]: step2 === "completed" && isPhotoAvailable })}>
                      <CameraIcon className={s.stepSvgIcon} />
                      {step2 === "completed" && isPhotoAvailable && <StepCompleteTickIcon className={s.stepTickIcon} />}
                    </div>
                    <div className={s.stepDetails}>
                      <h3 className={s.stepTitle} onClick={() => nextPage('amenities')}>
                        <FormattedMessage {...messages.step2SubHeading} />
                      </h3>
                      <p className={s.stepDescription}>
                        Sube fotos, añade el título y una descripción atractiva para que más personas te encuentren.
                      </p>
                    </div>
                  </div>
                  <div className={s.stepAction}>
                    {(step2 === "active" || (step2 === "completed" && !isPhotoAvailable)) && (
                      <a href="javascript:void(0);" className={s.actionLink} onClick={() => nextPage('amenities')}>
                        <FormattedMessage {...messages.continue} />
                        <span className={s.chevronIcon}>&rsaquo;</span>
                      </a>
                    )}
                    {step2 === "completed" && isPhotoAvailable && (
                      <a href="javascript:void(0);" className={s.actionLink} onClick={() => nextPage('amenities')}>
                        <FormattedMessage {...messages.editLabel} />
                        <span className={s.chevronIcon}>&rsaquo;</span>
                      </a>
                    )}
                    {step2 !== "active" && (!step2 || (step2 !== "completed" && isPhotoAvailable)) && (
                      <span className={s.chevronDisabled} onClick={() => nextPage('amenities')}>
                        &rsaquo;
                      </span>
                    )}
                  </div>
                </div>

                <div className={s.stepDivider}></div>

                {/* Step 3 */}
                <div className={cx(s.stepItem, { [s.stepItemCompleted]: step4 === "completed" })}>
                  <div className={s.stepLeft}>
                    <div className={cx(s.stepIconCircle, { [s.stepIconCircleCompleted]: step4 === "completed" })}>
                      <svg
                        className={s.stepSvgIcon}
                        viewBox="0 0 64 64"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="10" y="14" width="44" height="42" rx="7" />
                        <path d="M10 26 H54" />
                        <path d="M22 8 V18 M42 8 V18" />
                        <g fill="currentColor" stroke="none">
                          <circle cx="24" cy="35" r="2.5" />
                          <circle cx="32" cy="35" r="2.5" />
                          <circle cx="40" cy="35" r="2.5" />
                          <circle cx="24" cy="44" r="2.5" />
                          <circle cx="32" cy="44" r="2.5" />
                          <circle cx="40" cy="44" r="2.5" />
                        </g>
                      </svg>
                      {step4 === "completed" && <StepCompleteTickIcon className={s.stepTickIcon} />}
                    </div>
                    <div className={s.stepDetails}>
                      <h3 className={s.stepTitle} onClick={() => nextPage('title')}>
                        <FormattedMessage {...messages.step3SubHeading} />
                      </h3>
                      <p className={s.stepDescription}>
                        Configura la disponibilidad, la limpieza, los precios, las reglas de la casa y confirma tu calendario.
                      </p>
                    </div>
                  </div>
                  <div className={s.stepAction}>
                    {stepFour === true && (
                      <a href="javascript:void(0);" className={s.actionLink} onClick={() => nextPage('title')}>
                        <FormattedMessage {...messages.continue} />
                        <span className={s.chevronIcon}>&rsaquo;</span>
                      </a>
                    )}
                    {step4 === "completed" && (
                      <a href="javascript:void(0);" className={s.actionLink} onClick={() => nextPage('title')}>
                        <FormattedMessage {...messages.editLabel} />
                        <span className={s.chevronIcon}>&rsaquo;</span>
                      </a>
                    )}
                    {!stepFour && step4 !== "completed" && (
                      <span className={s.chevronDisabled} onClick={() => nextPage('title')}>
                        &rsaquo;
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Grid Footer */}
              <div className={s.gridFooter}>
                {/* Publish Button */}
                {listingSteps && isReady && listApprovalStatus === 'approved' && !isPublished && !userBanStatusValue && isShowButton && (
                  <div className={cx(s.listNextPosition, 'listNextPositionRTL')}>
                    <div className={s.listNextBackButton}>
                      <div>
                        <h3 className={cx(s.spaceTop1, s.textColor)}>
                          <FormattedMessage {...messages.readyToPublish} />
                        </h3>
                      </div>
                      <div className={s.btnFlex}>
                        <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(bt.btnPrimaryBorder)}>
                          <FormattedMessage {...messages.previewListing} />
                        </a>
                        <div className={s.displayInline}>
                          <Loader
                            type={"button"}
                            className={cx(bt.btnPrimary, bt.loaderButtonFlex)}
                            handleClick={() => ManagePublishStatus(id, 'publish')}
                            show={publishListLoading}
                            label={formatMessage(messages.publishNow)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* UnPublish Button */}
                {listingSteps && isReady && listApprovalStatus === 'approved' && isPublished && !userBanStatusValue && isShowButton && (
                  <div className={cx(s.listNextPosition, 'listNextPositionRTL')}>
                    <div className={s.listNextBackButton}>
                      <div>
                        <h3 className={cx(s.spaceTop1, s.textColor)}></h3>
                      </div>
                      <div className={s.btnFlex}>
                        <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(bt.btnPrimaryBorder)}>
                          <FormattedMessage {...messages.previewListing} />
                        </a>
                        <div className={s.displayInline}>
                          <Loader
                            type={"button"}
                            className={cx(bt.btnPrimary, bt.loaderButtonFlex)}
                            handleClick={() => ManagePublishStatus(id, 'unPublish')}
                            show={publishListLoading}
                            label={formatMessage(messages.unPublishNow)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Submit for verification Button */}
                {!isAdmin && listingSteps && isReady && !listApprovalStatus && !userBanStatusValue && isShowButton && (
                  <div className={cx(s.listNextPosition, 'listNextPositionRTL')}>
                    <div className={s.listNextBackButton}>
                      <div>
                        <h3 className={cx(s.spaceTop1, s.textColor)}>
                          <FormattedMessage {...messages.readyForVerification} />
                        </h3>
                      </div>
                      <div className={s.btnFlex}>
                        <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(bt.btnPrimaryBorder)}>
                          <FormattedMessage {...messages.previewListing} />
                        </a>
                        <div className={s.displayInline}>
                          <Loader
                            type={"button"}
                            className={cx(bt.btnPrimary, bt.loaderButtonFlex)}
                            handleClick={() => submitForVerification(id, 'pending')}
                            show={publishListLoading}
                            label={formatMessage(messages.submitForVerification)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Ready for Approval */}
                {!isAdmin && listingSteps && isReady && listApprovalStatus === 'pending' && !userBanStatusValue && isShowButton && (
                  <div className={cx(s.listNextPosition, 'listNextPositionRTL')}>
                    <div className={s.listNextBackButton}>
                      <div>
                        <h3 className={cx(s.spaceTop1, s.textColor)}>
                          <FormattedMessage {...messages.readyForApproval} />
                        </h3>
                      </div>
                      <div className={s.btnFlex}>
                        <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(bt.btnPrimaryBorder)}>
                          <FormattedMessage {...messages.previewListing} />
                        </a>
                        <div className={s.displayInline}>
                          <Loader
                            type={"button"}
                            className={cx(bt.btnPrimary, bt.loaderButtonFlex)}
                            disabled={true}
                            label={formatMessage(messages.waitingForAdmin)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Submit for appeal Button */}
                {!isAdmin && listingSteps && isReady && listApprovalStatus === 'declined' && !userBanStatusValue && isShowButton && (
                  <div className={cx(s.listNextPosition, 'listNextPositionRTL')}>
                    <div className={s.listNextBackButton}>
                      <div>
                        <h3 className={cx(s.spaceTop1, s.textColor)}>
                          <FormattedMessage {...messages.readyForVerification} />
                        </h3>
                      </div>
                      <div className={s.btnFlex}>
                        <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(bt.btnPrimaryBorder)}>
                          <FormattedMessage {...messages.previewListing} />
                        </a>
                        <div className={s.displayInline}>
                          <Loader
                            type={"button"}
                            className={cx(bt.btnPrimary, bt.loaderButtonFlex)}
                            handleClick={() => submitForVerification(id, 'pending')}
                            label={formatMessage(messages.submitForAppeal)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Approve/Decline Admin Button */}
                {isAdmin && listingSteps && isReady && (listApprovalStatus === 'pending' || !listApprovalStatus) && !userBanStatusValue && isShowButton && (
                  <div className={cx(s.listNextPosition, 'listNextPositionRTL')}>
                    <div className={s.listNextBackButton}>
                      <div className={'existingSelect'}>
                        <select className={cx(s.formSelect)} value={listApprovalStatus} onChange={this.handleApprove}>
                          <option value="pending">{formatMessage(messages.messageStatus5)}</option>
                          <option value="approved">{formatMessage(messages.approved)}</option>
                          <option value="declined">{formatMessage(messages.declined)}</option>
                        </select>
                      </div>
                      <div>
                        <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(bt.btnPrimaryBorder)}>
                          <FormattedMessage {...messages.previewListing} />
                        </a>
                      </div>
                    </div>
                  </div>
                )}

                {isAdmin && listingSteps && isReady && listApprovalStatus === 'declined' && !userBanStatusValue && isShowButton && (
                  <div className={cx(s.listNextPosition, 'listNextPositionRTL')}>
                    <div className={s.listNextBackButton}>
                      <div>
                        <h3 className={cx(s.spaceTop1, s.textColor)}>
                          <FormattedMessage {...messages.declineAdmin} />
                        </h3>
                      </div>
                      <div>
                        <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(bt.btnPrimaryBorder)}>
                          <FormattedMessage {...messages.previewListing} />
                        </a>
                      </div>
                    </div>
                  </div>
                )}

                {userBanStatusValue == true && isShowButton && (
                  <div className={cx(s.listNextPosition, 'listNextPositionRTL')}>
                    <div className={cx(s.listNextBackButton, s.flexEnd)}>
                      <div>
                        <a target="_blank" href={"/rooms/" + id + "/preview"} className={cx(bt.btnPrimaryBorder)}>
                          <FormattedMessage {...messages.previewListing} />
                        </a>
                      </div>
                    </div>
                  </div>
                )}

                {!isShowButton && (
                  <div className={cx(s.listNextPosition, 'listNextPositionRTL')}>
                    <div className={cx(s.listNextBackButton, s.flexCenter)}>
                      <div>
                        <h3 className={s.spaceTop1}>
                          <FormattedMessage {...messages.listDeleted} />
                        </h3>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

const mapState = (state) => ({
  listingSteps: state.location.listingSteps,
  stepsLoading: state.location.stepsLoading,
  account: state.account.data,
  publishListLoading: state.location.publishListLoading,
  userData: state.account.data,
});

const mapDispatch = {
  ManagePublishStatus,
  submitForVerification,
  approveListing,
  openCommentModal,
  closeCommentModal
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(ExistingPage1)));
